import React, { Component } from 'react';
import { connect } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import PropTypes from 'prop-types';
import KobooRoundInput from '../../constants/KobooRoundInput.css';
import KobooButton from '../Layout/KobooButton';
import styles from '../../constants/stylesDefault';
import * as routes from '../../constants/routes';
import { getUsers, putUser } from '../../store/users/actions';
import Spinner from '../Layout/Spinner';


const byPropKey = (propertyName, value) => () => ({
  [propertyName]: value,
});

const getStateByUserInfo = userInfo => ({
  email: userInfo.email ? userInfo.email : '',
  firstname: userInfo.firstname ? userInfo.firstname : '',
  lastname: userInfo.lastname ? userInfo.lastname : '',
  mobile: userInfo.mobile ? userInfo.mobile : '',
});

const INITIAL_STATE = {
  email: '',
  firstname: '',
  lastname: '',
  mobile: ''
};

export class EditProfileForm extends Component {
  constructor(props) {
    super(props);
    if (props.users && props.authUser) {
      const userInfo = props.users[props.authUser.uid];
      this.state = {
        ...getStateByUserInfo(userInfo)
      };
    } else {
      this.state = { ...INITIAL_STATE };
    }
  }

  static propTypes = {
    authUser: PropTypes.object,
    users: PropTypes.object || PropTypes.array,
  };

  static getDerivedStateFromProps(props, state) {
    let newState = null;
    if (!props.users && !props.pending) {
      props.getUsers();
    }
    if (props.users && props.authUser && state.email === INITIAL_STATE.email) {
      if (props.authUser.uid in props.users) {
        const userInfo = props.users[props.authUser.uid];
        newState = { ...newState, ...getStateByUserInfo(userInfo) }
      }
    }
    return newState;
  }

  onSubmit = (event) => {
    const {
      email,
      firstname,
      lastname,
      mobile,
    } = this.state;
    this.props.putUser(this.props.authUser.uid, email, firstname, lastname, mobile)
      .then(value => {
        if (value) {
          this.props.history.push(routes.ACCOUNT);
        }
      });
    event.preventDefault();
  };

  render() {
    const {
      email,
      firstname,
      lastname,
      mobile,
    } = this.state;

    return (
      <form onSubmit={this.onSubmit} style={styles.center}>
        <TextField
          style={KobooRoundInput.round}
          placeholder="Email"
          id="profile-email"
          type="text"
          onChange={event => this.setState(byPropKey('email', event.target.value))}
          margin="normal"
          value={email}
          InputProps={{
            disableUnderline: true,
          }}
        />
        <TextField
          style={KobooRoundInput.round}
          placeholder="Nom"
          id="profile-lastname"
          type="text"
          onChange={event => this.setState(byPropKey('lastname', event.target.value))}
          margin="normal"
          value={lastname}
          InputProps={{
            disableUnderline: true,
          }}
        />
        <TextField
          style={KobooRoundInput.round}
          placeholder="Prénom"
          id="profile-firstname"
          type="text"
          onChange={event => this.setState(byPropKey('firstname', event.target.value))}
          margin="normal"
          value={firstname}
          InputProps={{
            disableUnderline: true,
          }}
        />
        <TextField
          style={KobooRoundInput.round}
          placeholder="Téléphone"
          id="profile-mobile"
          type="text"
          onChange={event => this.setState(byPropKey('mobile', event.target.value))}
          margin="normal"
          value={mobile}
          InputProps={{
            disableUnderline: true,
          }}
        />
        <KobooButton disabled={false} type="submit">
          {this.props.sending ?
            <Spinner style={{ parent: { margin: '4px auto 0' }, child: {} }}/> : 'Éditer'}
        </KobooButton>
      </form>
    );
  }
}

function mapStateToProps(state) {
  return {
    authUser: state.users.authUser,
    pending: state.users.pending,
    sending: state.users.sending,
    users: state.users.content
  };
}

export default connect(mapStateToProps, { getUsers, putUser })(EditProfileForm);



// WEBPACK FOOTER //
// ./src/components/EditProfileForm/EditProfileForm.jsx